export default __webpack_public_path__ + "static/media/icon-injection.65bad838.svg";